import { handleErrorApi } from "../../helpers/randoms";
import { finishSpinner, startSpinner } from "../ui/spinner";
import { cleanAreasFisicas, cleanSubAreasFisicas, cleanUsuarioAreasFisicas, deleteAreasFisicas, endAreasFisicasReducer, getAreasFisicas, getSubAreasFisicas, getUsuarioAreasFisicas, newAreaFisica, newStateAreasFisicas, putAreaFisica, removeAreaFisica, startAreasFisicasReducer } from "../../reducers/usuarios/areasFisicasReducer";
import { fetchConToken } from "../../helpers/fetch";
import { startAlerta } from "../ui/alertas";

export const getAreasFisicasAction = () => async (dispatch) => {
    dispatch(startSpinner());
    dispatch(startAreasFisicasReducer());
    try {
        const response = await fetchConToken('AreasFisicas');
        const body = await response.json();
        if (response.ok) {
        dispatch(getAreasFisicas(body));
        dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch(cleanAreasFisicas());
        dispatch(endAreasFisicasReducer());
        handleErrorApi(dispatch, error, "Error al traer areas fisicas", "Ha ocurrido un error. Intente nuevamente");
    }
};

export const getSubAreasFisicasAction = () => async (dispatch) => {
    dispatch(startSpinner());
    dispatch(startAreasFisicasReducer());
    try {
        const response = await fetchConToken('AreasFisicas/SubAreasFisicas');
        const body = await response.json();
        if (response.ok) {
        dispatch(getSubAreasFisicas(body));
        dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch(cleanSubAreasFisicas());
        dispatch(endAreasFisicasReducer());
        handleErrorApi(dispatch, error, "Error al traer subAreas fisicas", "Ha ocurrido un error. Intente nuevamente");
    }
};

export const getUsuarioAreaFisicaAction = (idUsuario) => async (dispatch) => {
    dispatch(startSpinner());
    dispatch(startAreasFisicasReducer());
    try {
        const response = await fetchConToken(`AreasFisicas/UsuarioArea/${idUsuario}`);
        const body = await response.json();
        if (response.ok) {
            dispatch(getUsuarioAreasFisicas(body));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch(cleanUsuarioAreasFisicas());
        dispatch(endAreasFisicasReducer());
        handleErrorApi(dispatch, error, "Error al traer area fisica de usuario", "Ha ocurrido un error. Intente nuevamente");
    }
};

export const postAreasFisicasAction = (data, setearValores) => async (dispatch) => {
    dispatch(startSpinner());
    dispatch(startAreasFisicasReducer());
    try {
        const response = await fetchConToken(
            `AreasFisicas`,
            data,
            "POST"
        );
        const body = await response.json();
        if (response.ok) {
            setearValores(body);
            dispatch(newStateAreasFisicas(body));
            dispatch(startAlerta(`Area guardada`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch(cleanAreasFisicas());
        dispatch(endAreasFisicasReducer());
        handleErrorApi(dispatch, error, "Error al guardar area fisica", "Ha ocurrido un error. Intente nuevamente");
    }
};

export const putAreasFisicasAction = (data, setearValores) => async (dispatch) => {
    dispatch(startSpinner());
    dispatch(startAreasFisicasReducer());
    try {
        const response = await fetchConToken(
            `AreasFisicas`,
            data,
            "PUT"
        );
        const body = await response.json();
        if (response.ok) {
            setearValores(body);
            dispatch(newStateAreasFisicas(body));
            dispatch(startAlerta(`Area modificada`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch(cleanAreasFisicas());
        dispatch(endAreasFisicasReducer());
        handleErrorApi(dispatch, error, "Error al modificar area fisica", "Ha ocurrido un error. Intente nuevamente");
    }
};

export const deleteAreasFisicasAction = (data, setearValores) => async (dispatch) => {
    dispatch(startSpinner());
    dispatch(startAreasFisicasReducer());
    try {
        const response = await fetchConToken(
            `AreasFisicas`,
            data,
            "DELETE"
        );
        const body = await response.json();
        if (response.ok) {
            setearValores({
                idArea: "",
                idSubArea: ""
            })
            dispatch(deleteAreasFisicas(data.idUsuario));
            dispatch(startAlerta(`Area eliminada`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch(cleanAreasFisicas());
        dispatch(endAreasFisicasReducer());
        handleErrorApi(dispatch, error, "Error al eliminar area fisica", "Ha ocurrido un error. Intente nuevamente");
    }
};

export const putSubAreasFisicasAction = (data, setearValores, values) => async (dispatch) => {
    dispatch(startSpinner());
    dispatch(startAreasFisicasReducer());
    try {
        const response = await fetchConToken(
            `AreasFisicas/SubArea`,
            data,
            "PUT"
        );
        const body = await response.json();
        if (response.ok) {
            if(!values.idSubArea) dispatch(startAlerta(`Sub Area guardada`,'success','Comando Exitoso'));
            else{
                if(values.idSubArea === data.idSubArea) dispatch(startAlerta(`Sub Area eliminada`,'success','Comando Exitoso'));
                else dispatch(startAlerta(`Sub Area modificada`,'success','Comando Exitoso'));
            };
            setearValores(body);
            dispatch(newStateAreasFisicas(body));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch(cleanAreasFisicas());
        dispatch(endAreasFisicasReducer());
        handleErrorApi(dispatch, error, "Error al modificar subarea fisica", "Ha ocurrido un error. Intente nuevamente");
    }
};



// Actios Abm Areas Fisicas
export const modificarAreasFisicasAction = (data) => async (dispatch) => {
    dispatch(startSpinner());
    dispatch(startAreasFisicasReducer());
    try {
        const response = await fetchConToken(
            `AreasFisicas/ModificarAreaFisica`,
            data,
            "PUT"
        );
        const body = await response.json();
        if (response.ok) {
            dispatch(putAreaFisica(data));
            dispatch(startAlerta(`Area modificada`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch(endAreasFisicasReducer());
        handleErrorApi(dispatch, error, "Error al modificar area fisica", "Ha ocurrido un error. Intente nuevamente");
    }
};

export const removeAreasFisicasAction = (data) => async (dispatch) => {
    dispatch(startSpinner());
    dispatch(startAreasFisicasReducer());
    try {
        
        const response = await fetchConToken(
            `AreasFisicas/RemoveAreaFisica/${data}`,
            {},
            "DELETE"
        );
        const body = await response.json();
        if (response.ok) {
            dispatch(removeAreaFisica(data));
            dispatch(startAlerta(`Area eliminada`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch(endAreasFisicasReducer());
        handleErrorApi(dispatch, error, "Error al eliminar area fisica", "Ha ocurrido un error. Intente nuevamente");
    }
};

export const agregarAreasFisicasAction = (data) => async (dispatch) => {
    dispatch(startSpinner());
    dispatch(startAreasFisicasReducer());
    try {
        
        const response = await fetchConToken(
            `AreasFisicas/AgregarAreaFisica`,
            data,
            "POST"
        );
        const body = await response.json();
        if (response.ok) {
            dispatch(newAreaFisica(data));
            dispatch(startAlerta(`Area agregada`,'success','Comando Exitoso'));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch(endAreasFisicasReducer());
        handleErrorApi(dispatch, error, "Error al agregar area fisica", "Ha ocurrido un error. Intente nuevamente");
    }
};

